<script lang="ts">
  import { authorizationCheck } from "@shared/svelte/Modules/AuthorizationCheck.svelte";

  export let authName: string;

  let visible = false;

  visible = authorizationCheck(authName);

</script>

{#if visible}
  <slot />
{/if}
